import script from "./newFleetButton.vue?vue&type=script&setup=true&lang=js"
export * from "./newFleetButton.vue?vue&type=script&setup=true&lang=js"

import "./newFleetButton.vue?vue&type=style&index=0&id=795d06d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795d06d8"]])

export default __exports__